var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('super-admin-layout',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"md":"12"}},[_c('h4',[_vm._v("Super Admin Dashboard")]),_c('p',[_vm._v("TBC")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }